











































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SetAtomsFromPdbCommand from './SetAtomsFromPdbCommand';
import {
  INCREMENT_EDIT_STEP,
  SET_MD_FILES,
  ATOMS_FROM_PDB_REQUEST,
  IS_LOADING,
} from './RedMatCalculationModule';
import RedMatCalculationTypes from './RedMatCalculationTypes';

export default Vue.extend({
  name: 'DefineSystem',
  data() {
    return {
      ligandFile: null as File | null,
      receptorFile: null as File | null,
      amberTopology: null as File | null,
      amberTrajectory: null as File | null,
      formIsValid: false,
      isRequiredRule: (i: any) => !!i || 'File is required',
    };
  },
  computed: {
    ...mapGetters({
      isLoading: IS_LOADING,
    }),
    isMdCalculation() {
      return this.$store.state.redMatCalculation
        .calculationType === RedMatCalculationTypes.MolecularDynamics;
    },
  },
  methods: {
    onClickNext() {
      // save MD files to store
      this.$store.dispatch(SET_MD_FILES, {
        topology: this.amberTopology,
        trajectory: this.amberTrajectory,
      });

      // make request to parse PDBs
      const command: SetAtomsFromPdbCommand = {
        ligandPdb: this.ligandFile as File,
        receptorPdb: this.receptorFile as File,
      };

      this.$store.dispatch(ATOMS_FROM_PDB_REQUEST, command)
        .then(() => {
          this.$store.dispatch(INCREMENT_EDIT_STEP);
        })
        .catch(() => {
          // do nothing
        });
    },
  },
});
